import { TextField } from "@mui/material";
import { memo } from "react";

//Display the functional equivalent of <a href='url'> 'display' </a>
const CreateHyperlink = ({ url, display, openInNewTab }) => {
  if (url?.trim()) {
    if (url.toLowerCase().indexOf("http:") === 0 || url.toLowerCase().indexOf("https:") === 0) {
      //For absolute path
      //Ex. https://pubmed.ncbi.nlm.nih.gov/34406727/
      //Ex. https://fevir.net/456
      //Ex. https://fevir.net/resources/ResearchStudy/456
      return <>
        {openInNewTab ?
          <a href={url} target="_blank" rel="noopener noreferrer">{display || url}</a>
          :
          <a href={url}>{display || url}</a>
        }
      </>
    } else {
      //For relative paths
      let urlCleaned = url.trim();
      if (urlCleaned.split("/").length === 2 && urlCleaned.charCodeAt(0) >= 65 && urlCleaned.charCodeAt(0) <= 90) {  //If it only has one slash and starts with a capital letter, then it's likely a relative path to a FHIR resource on the FEvIR platform
        //Ex: Citation/789 will become /resources/Citation/789
        url = "https://fevir.net/resources/" + urlCleaned;
        if (urlCleaned.split("/")[0] === "Composition") {
          return <>
            {openInNewTab ?
              <span>
                <a href={"https://computablepublishing.com/" + urlCleaned}
                  target="_blank"
                  rel="noopener noreferrer">{display || "https://computablepublishing.com/" + urlCleaned}
                </a> or on <a href={url} target="_blank"
                  rel="noopener noreferrer">FEvIR Platform
                </a>
              </span>
              :
              <span>
                <a href={"https://computablepublishing.com/" + urlCleaned}>
                  {display || "https://computablepublishing.com/" + urlCleaned}
                </a> or on <a href={url}>FEvIR Platform</a>
              </span>
            }
          </>
        } else {
          return <>
            {openInNewTab ?
              <a href={url} target="_blank" rel="noopener noreferrer">{display || url}</a>
              :
              <a href={url}>{display || url}</a>
            }
          </>
        }
      } else if (urlCleaned.toLowerCase().indexOf("/fli/") === 0) {
        return <>
          {openInNewTab ?
            <a href={urlCleaned} target="_blank" rel="noopener noreferrer">{display || "FLI: " + urlCleaned.replace("/FLI/", "").replace("/fli/", "")}</a>
            :
            <a href={urlCleaned}>{display || "FLI: " + urlCleaned.replace("/FLI/", "").replace("/fli/", "")}</a>
          }
        </>
      } else {
        //If it's a relative path outside of our system or it's just some string, then just display it without a hyperlink
        let returnDisplay = display || url || "";
        return <>{returnDisplay}</>
      }
    }
  } else {
    return <></>
  }
};

const DisplayFromFHIRUri = ({ uri }) => {
  if (uri?.trim()) {
    if (typeof uri !== "string") {
      return <>[ERROR: Uri data not interpretable.]</>;
    } else {
      return <CreateHyperlink url={uri} openInNewTab={true} />;
    }
  } else {
    return <></>
  }
}

const UriEntry = memo(({ elementName, fieldLabel, startingValue, setResourceState }) => {
  return <div>
    <TextField style={{ width: "100%", marginTop: "12px" }} multiline
      className="inputField" type='text' label={fieldLabel} size="small" variant='outlined'
      value={startingValue || ""}
      onChange={(e) => {
        setResourceState(prevState => { return { ...prevState, [elementName]: e.target.value } })
      }} />
    {startingValue && <div><b>{fieldLabel} will display as: </b><DisplayFromFHIRUri uri={startingValue} /><br /><br /></div>}
  </div>
});

export default UriEntry;
export { CreateHyperlink, DisplayFromFHIRUri };